import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../../../common/general/ButtonGroup';

import './PatientContentConfirmation.scss';
export default function PatientContentConfirmation({ message, content, onConfirm, onDeny }) {
  const { t } = useTranslation();
  return (
    <div className="patient-content-confirmation p-3">
      <span>{message}</span>
      <ButtonGroup>
        <Button priority="medium" onClick={onConfirm}>
          {t('yes')}
        </Button>
        <Button onClick={onDeny}>{t('no')}</Button>
      </ButtonGroup>
    </div>
  );
}
